import { useState } from 'react'
import CloseBubbleIcon from '../../../assets/svgs/CloseBubble'
import style from '../register/Register.module.css'
import emailValidation from '../../../utils/EmailValidation'
import ErrorIcon from '../../../assets/svgs/Error'
import axios from 'axios'

const apiUrl = process.env.REACT_APP_API_URL

const ForgotPassword = ({ handleAuth, setOpenAuth }) => {
  const [error, setError] = useState({})
  const [formData, setFormData] = useState({ email: '' })
  const { errors, isValid } = emailValidation(formData)
  const renderErrorMessage = (message) => (
    <p className={style.errorMessage}>{message}</p>
  )

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
    if (error[name]) {
      setError((prevError) => {
        const newError = { ...prevError }
        delete newError[name]
        return newError
      })
    }
  }
  const handleSubmit = async () => {
    if (!isValid) {
      setError(errors)
      return
    }

    try {
      await axios.post(`${apiUrl}/auth/forgotpassword`, formData)

      sessionStorage.setItem('forgotPasswordEmail', formData.email)

      setOpenAuth('resetPassword')
    } catch (err) {
      setError({ ...error, email: err.response.data.error })
      return
    }
  }
  return (
    <div className={style.mainContainer}>
      <div className={style.container}>
        <div className={style.closeBubble} onClick={handleAuth}>
          <CloseBubbleIcon />
        </div>
        <div className={style.textBox}>
          <p className={style.title}>Forgot password ?</p>
          <p className={style.subTitle}>
            Don’t worry, enter your email and we’ll send you reset instructions
          </p>
        </div>
        <div className={style.form}>
          <div className={style.inputContainerSub}>
            {error.email && (
              <div className={style.errorIconContainer}>
                <ErrorIcon />
              </div>
            )}
            <input
              className={error.email ? style.inputFieldError : style.inputField}
              placeholder="Email"
              value={formData.email}
              onChange={handleInputChange}
              name="email"
            />
            <p style={{ margin: 0, height: '20px' }}>
              {error.email && renderErrorMessage(error.email)}
            </p>
          </div>
          <button className={style.button} onClick={handleSubmit}>
            Continue
          </button>
          <div className={style.divider}>
            <div className={style.hr}></div>
            <p className={style.dividerText}> Or</p>
          </div>
          <button
            type="button"
            className={style.mobileButton}
            onClick={handleAuth}
          >
            Cancel{' '}
          </button>
        </div>
      </div>
    </div>
  )
}
export default ForgotPassword
